import { createTranslationProvider } from '@rx-applications/shared/transloco';

export const TRANSLATION_SCOPE = 'adminNavigationMenu';

const loaderFn = (lang: string) => import(`./${lang}.json`);
export const translationProvider = createTranslationProvider(loaderFn, TRANSLATION_SCOPE);
